import { WeekDay } from '@angular/common';
import { Injectable } from '@angular/core';

import { DayOfWeek } from '@bayclubs/court-booking-employee-api';

@Injectable({
    providedIn: 'root'
})
export class WeekDayService {
    private days: DayOfWeek[] = this.wholeWeek();
    constructor() { }

    wholeWeek(): DayOfWeek[] {
        return [
            DayOfWeek.Sunday,
            DayOfWeek.Monday,
            DayOfWeek.Tuesday,
            DayOfWeek.Wednesday,
            DayOfWeek.Thursday,
            DayOfWeek.Friday,
            DayOfWeek.Saturday
        ];
    }

    daysSorter(day1: DayOfWeek, day2: DayOfWeek) {
        const i1 = this.days.indexOf(day1);
        const i2 = this.days.indexOf(day2);
        return i1 - i2;
    }

    public toDayOfWeek(dayOfWeek: number): DayOfWeek {
        switch (dayOfWeek) {
            case 0:
                return DayOfWeek.Sunday;
            case 1:
                return DayOfWeek.Monday;
            case 2:
                return DayOfWeek.Tuesday;
            case 3:
                return DayOfWeek.Wednesday;
            case 4:
                return DayOfWeek.Thursday;
            case 5:
                return DayOfWeek.Friday;
            case 6:
                return DayOfWeek.Saturday;
            default:
                break;
        }
    }

    public toWeekDay(dayOfWeek: DayOfWeek): WeekDay {
        switch (dayOfWeek) {
            case DayOfWeek.Monday:
                return WeekDay.Monday;
            case DayOfWeek.Tuesday:
                return WeekDay.Tuesday;
            case DayOfWeek.Wednesday:
                return WeekDay.Wednesday;
            case DayOfWeek.Thursday:
                return WeekDay.Thursday;
            case DayOfWeek.Friday:
                return WeekDay.Friday;
            case DayOfWeek.Saturday:
                return WeekDay.Saturday;
            case DayOfWeek.Sunday:
                return WeekDay.Sunday;
        }
    }
}
